export default function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
}
